var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternRightTop(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pattern-right-top_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 240 144",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".pattern-right-top_svg__st1{fill:#4f25b7}.pattern-right-top_svg__st4{fill:#6c36db}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-top_svg__st1",
    d: "M144 144H96V96h48v48zM48 48H0V0h48v48zM96 96H48V48h48v48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 0H48v24h24v24h24V0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#c193ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 48h48v24h-24v24h-24V48z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#6c36db"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pattern-right-top_svg__st4",
    d: "M240 96h-48l48 48V96zM192 144h-48l48-48v48zM96 0h48v48c-26.5 0-48-21.5-48-48zM192 0h38c5.5 0 10 4.5 10 10v38c-26.5 0-48-21.5-48-48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 48h-24c13.3 0 24-10.7 24-24v24zM168 0h24v24c0-13.3-10.7-24-24-24zm-24 24V0h24c-13.3 0-24 10.7-24 24zm0 0v24h24c-13.3 0-24-10.7-24-24zm24-9.6c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6-4.3-9.6-9.6-9.6z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ad78ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternRightTop);
export default "/_next/static/images/028c9ab392bdbb8f9ee1c72ed662a51f.svg";
export { ForwardRef as ReactComponent };